import { useEffect, useState } from "react";

const GetImagePath = (
    publicUrl: string | undefined,
    image: string | undefined | null
): string => {
    const [imageUrl, setImageUrl] = useState("");

    useEffect(() => {
        if (image && publicUrl) {
            setImageUrl(`${publicUrl}/${image}`);
            return;
        }

        setImageUrl("");
    }, [image, publicUrl]);

    return imageUrl;
};

export default GetImagePath;
